<template>
  <div id="pk-rule">
      <div class="img-box">
          <img src="@/assets/active/team-pk/rule/1.png" alt="">
      </div>
      <div class="img-box">
          <img src="@/assets/active/team-pk/rule/2.png" alt="">
      </div>
      <div class="img-box">
          <img src="@/assets/active/team-pk/rule/3.png" alt="">
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.img-box {
    img {
        height: auto;
        width: 100vw;
    }
    margin-bottom: -6px;
}
</style>